import { render, staticRenderFns } from "./ModalDeclineMessageParts.vue?vue&type=template&id=70fdd5d4&scoped=true"
import script from "./ModalDeclineMessageParts.vue?vue&type=script&lang=ts"
export * from "./ModalDeclineMessageParts.vue?vue&type=script&lang=ts"
import style0 from "./ModalDeclineMessageParts.vue?vue&type=style&index=0&id=70fdd5d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fdd5d4",
  null
  
)

export default component.exports